export default "__VITE_ASSET__C_Xo1Qr7__"